import React, { useCallback, useMemo, useState } from 'react';

import { parseReceivedNotifications } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import InfoBox from './InfoBox';
import { Message } from 'components';
import { Box, Typography } from '@mui/material';

const MessagesSection = props => {
    const { distributor } = props;

    const [expandedMessageId, setExpandedMessageId] = useState(null);
    const handleToggleExpand = useCallback(
        id => e => {
            setExpandedMessageId(prevState => (prevState === id ? null : id));
        },
        []
    );

    const receivedMessages = useMemo(
        () => parseReceivedNotifications(distributor?.user?.receivedNotifications || []),
        [distributor]
    );

    const hasMessages = Array.isArray(receivedMessages) && receivedMessages.length > 0;

    return (
        <InfoBox title={texts.MESSAGES} disableContentWrapper>
            {hasMessages ? (
                <Box display="flex" flexDirection="column" gap={2}>
                    {receivedMessages.map(message => (
                        <Message
                            key={message.id}
                            id={message.id}
                            expanded={expandedMessageId === message.id}
                            onToggleExpand={handleToggleExpand(message.id)}
                            title={message.title}
                            content={message.content}
                            type={message.type}
                        />
                    ))}
                </Box>
            ) : (
                <Box textAlign="center">
                    <Typography>{texts.NO_MESSAGE}</Typography>
                </Box>
            )}
        </InfoBox>
    );
};

export default MessagesSection;
